var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4997 14.0004H14.6997L14.3997 13.7004C15.5997 12.3004 16.1997 10.4004 15.8997 8.40042C15.3997 5.60042 13.0997 3.40042 10.2997 3.10042C6.09968 2.60042 2.49968 6.10042 2.99968 10.4004C3.29968 13.2004 5.59968 15.5004 8.29968 16.0004C10.2997 16.3004 12.1997 15.7004 13.5997 14.5004L13.8997 14.8004V15.6004L18.0997 19.8004C18.4997 20.2004 19.1997 20.2004 19.5997 19.8004C19.9997 19.4004 19.9997 18.7004 19.5997 18.3004L15.4997 14.0004ZM9.49968 14.0004C6.99968 14.0004 4.99968 12.0004 4.99968 9.50042C4.99968 7.00042 6.99968 5.00042 9.49968 5.00042C11.9997 5.00042 13.9997 7.00042 13.9997 9.50042C13.9997 12.0004 11.9997 14.0004 9.49968 14.0004Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.9b470231.svg";
export { ForwardRef as ReactComponent };